<template>
  <section class="product-design">
    <header>
      <h2>{{design.title}}</h2>
      <p class="subtitle is-hidden-mobile">
        {{design.subtitle}}
      </p>
    </header>
    <div class="container text-center">
      <img v-lazy="isEn ? enImage : cnImage" alt="" draggable="false">
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'ProductDesign',
  props: {
    design: Object
  },
  computed: {
    ...mapGetters(['language']),
    isEn () {
      return this.language === 'en'
    },
    cnImage () {
      return require('../../../static/images/product/custom-intro-cn.png')
    },
    enImage () {
      return require('../../../static/images/product/custom-intro-en.png')
    }
  }
}
</script>

<style lang="scss">
.product-design {
  img {
    max-width: 100%;
    height: auto;
  }
}
</style>
